import "core-js/modules/es6.regexp.search";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
export default {
  name: "supplierbutt",
  props: {
    interfaceId: {
      type: String,
      default: ""
    },
    // 请求接口方式默认POST
    strmethod: {
      type: String,
      default: "POST"
    },
    propsValue: {
      type: String,
      default: ""
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    appendtobody: {
      type: Boolean,
      default: true
    },
    disableds: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    buttenname: {
      type: String,
      default: ""
    },
    //公司名称
    corporatename: {
      type: String,
      default: ""
    },
    urls: {
      type: String,
      default: ""
    },
    //判断是否要传公司名称
    corporatenamesta: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {}
    },
    title: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  data: function data() {
    return {
      loadingbut: false,
      like1: "",
      like2: "",
      arr: "",
      mea: "",
      paces: "",
      sizename: "",
      checkedTxtt: "",
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      filteredList: [],
      innerValue: "",
      keyword: "",
      keyname: "",
      checked: "",
      checkedTxt: "",
      listLoading: false,
      visible: false,
      refreshDataList: [],
      dataForm: {}
    };
  },
  watch: {},
  computed: {
    propsLabel: function propsLabel() {
      return this.columnOptions[0].value;
    }
  },
  created: function created() {
    this.keyword = "";
    this.getData();
    // this.initData()
  },
  methods: {
    getData: function getData() {
      var _this = this;
      if (!this.interfaceId) return;
      this.listLoading = true;
      var _query = _objectSpread({}, this.listQuery);
      var query = {};
      for (var key in _query) {
        if (Array.isArray(_query[key])) {
          query[key] = _query[key].join();
        } else {
          query[key] = _query[key];
        }
      }
      var arrlist = "";
      console.log(this.keyword, "this.keyword");
      if (this.keyword == "") {
        arrlist = "";
        // this.arr = "";
        // this.arrr = "";
        // this.like1 = "";
        // this.acs = "";
        // this.acss = "";
        // this.like2 = "";
      } else {
        arrlist = "AND F_CODE LIKE'%".concat(this.keyword, "%'OR F_NAME LIKE'%").concat(this.keyword, "%'OR F_FIRSTABC LIKE'%").concat(this.keyword, "%'");
        // this.arr = "AND F_CODE ";
        // this.like1 = "LIKE";
        // this.arrr = "'%" + this.keyword + "%'";
        // this.acs = "OR F_NAME ";
        // this.acss = "'%" + this.keyword + "%'";
        // this.like2 = "LIKE";
      }
      request({
        url: this.interfaceId + "/" + this.listQuery.currentPage + "/" + this.listQuery.pageSize,
        method: this.strmethod,
        data: {
          // "WhereSql": "AND F_CODE=" + "'" + this.keyword + "'" + "AND ITEM_NAME=" + "'" + this.keyname
          WhereSql: arrlist
          // text:
        }
      }).then(function (res) {
        _this.filteredList = res.data.list;
        _this.listLoading = false;
        _this.total = res.data.pagination.total;
        _this.setDefault();
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    search: function search() {
      this.getData();
    },
    reset: function reset() {
      this.keyword = "";
      this.keyname = "";
      this.filteredList = this.list;
      this.search();
    },
    refreshs: function refreshs() {
      this.keyword = "";
      this.getData();
    },
    openDialog: function openDialog() {
      // this.keyword = "";
      if (this.disableds == true && this.corporatename == "" && this.corporatenamesta == false) {
        this.$message({
          message: "请先输入公司名称",
          type: "warning",
          duration: 1000
        });
      } else if (this.disabled == true && this.corporatenamesta == true) {} else {
        this.checked = this.value;
        this.visible = true;
        if (!this.list.length) {
          // this.keyword = this.innerValue;
          this.search();
        } else {
          this.filteredList = this.list;
        }
      }
    },
    select: function select() {
      var _this2 = this;
      this.loadingbut = true;
      this.innerValue = this.checkedTxt;
      // for (const key in this.data) {
      //   if (this.data[key] == undefined) {
      //     this.data[key] = this.checked;
      //   }
      // }
      request({
        url: "/api/DataCommon/Common/DataInterfacePage/Partner/1/20",
        method: "POST",
        data: {
          WhereSql: "AND ID LIKE'".concat(this.checked, "'")
        }
      }).then(function (res) {
        _this2.dataForm.FCode = res.data.list[0].F_CODE;
        _this2.dataForm.FName = res.data.list[0].F_NAME;
        _this2.dataForm.FFirstabc = res.data.list[0].F_FIRSTABC;
        _this2.dataForm.Company = res.data.list[0].COMPANY_NAME;
        _this2.dataForm.Fid = _this2.checked;
        request({
          url: _this2.urls,
          method: _this2.strmethod,
          data: _objectSpread({}, _this2.dataForm)
        }).then(function (res) {
          _this2.$message({
            type: "success",
            message: res.msg,
            duration: 1000,
            onClose: function onClose() {
              _this2.visible = false, _this2.$emit("refresh", true);
              _this2.loadingbut = false;
            }
          });
        }).catch(function () {
          _this2.loadingbut = false;
        });
      });
    },
    rowClick: function rowClick(row) {
      this.checked = row[this.propsValue];
      this.checkedTxt = row[this.propsLabel];
      this.checkedTxtt = row.CUSTOMERNAME;
    }
  }
};